<template>
  <div>
    <p>Med det här verktyget kan du exportera data från de 30 senaste dagarna från din Nexa Bridge X. Logga in nedan och välj sedan vilken enhet du vill exportera från.</p>

    <div v-if="errorMessage.length" style="margin-bottom:25px;padding:8px;background-color:#e74c3c;color:#FFF;border-radius:3px;border:1px solid #c0392b;">
      {{ errorMessages[errorMessage] }}
    </div>

    <div v-if="!bridges.length">
      <form>
        <input type="email" name="email" required placeholder="Din e-post" v-model="email" :disabled="loadingLogin">
        <input type="password" name="password" required placeholder="Ditt lösenord" v-model="password" :disabled="loadingLogin" @keyup.enter="doLogin">
        <button :disabled="!buttonOk" @click="doLogin">
          <div v-if="loadingLogin" aria-busy="true"></div>
          <div v-else>Logga in</div>
        </button>
      </form>
    </div>
    <div v-else>
      <h5>Välj din Nexa Bridge X i listan</h5>

      <table>
        <thead>
          <tr>
            <th scope="col">Bridge</th>
            <th scope="col">Online</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="bridge in bridges" :key="bridge.id" style="cursor:pointer;" @click="selectBridge(bridge.id, bridge.name)">
            <th>{{ bridge.name }}</th>
            <th><span :style="{ color:(bridge.connected ? '#27ae60' : '#e74c3c') }">{{ bridge.connected ? 'Online' : 'Offline' }}</span></th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Login',
  data: () => ({
    email: '',
    password: '',
    loadingLogin: false,
    errorMessage: '',
    errorMessages: {
      InvalidUsernameOrPassword: 'Felaktig e-post eller lösenord, försök igen.'
    },
    bridges: [],
    selectedBridge: ''
  }),
  async created () {
    if (this.$root.loggedIn) {
      this.loadingLogin = true
      
      const bridges = await this.fetch('/bridges')
      
      if (bridges.length > 0) {
        if (bridges.length === 1) {
          this.selectedBridge = bridges[0].id
        }
        else {
          this.bridges = bridges
        }
      }
    }
  },
  computed: {
    emailOk () {
      return this.email.length > 0 && this.email.includes('@') && this.email.includes('.')
    },

    buttonOk () {
      return !this.loadingLogin && this.email.length > 0 && this.email.includes('@') && this.email.includes('.') && this.password.length > 3
    },
  },
  methods: {
    async selectBridge (bridgeId, bridgeName) {
      await localStorage.setItem('bridgeName', bridgeName)

      this.selectedBridge = bridgeId
      this.$root.selectedBridge = bridgeId
      this.$root.bridgeName = bridgeName
    },

    async doLogin () {
      this.loadingLogin = true

      const res = await this.fetch(`/account/login`, {
        email: this.email,
        password: this.password
      })

      this.loadingLogin = false

      if ('success' in res) {
        // Login success or fail
        if (res.success === true) {
          await localStorage.setItem(`token`, res.token)
          this.$root.loggedIn = true
          //
          const bridges = await this.fetch('/bridges')

          if (bridges.length > 0) {
            if (bridges.length === 1) {
              this.selectBRidge(bridges[0].id, bridges[0].name)
            }
            else {
              this.bridges = bridges
            }
          }
        }
        else {
          //
          this.failed(res.error)
        }
      }
    },

    failed (reason) {
      this.errorMessage = reason
      this.password = ''

      setTimeout(() => {
        this.errorMessage = ''
      }, 2500)
    },

    async fetch (path, body = {}, headers = {}) {
      headers.Accept = 'application/json'
      let method = 'GET'

      if (Object.keys(body).length) {
        method = 'POST'
        headers['Content-type'] = 'application/json'
        body = JSON.stringify(body)
      }

      const token = localStorage.getItem('token')

      if (token) {
        headers.Authorization = `Basic ${btoa(`X:${token}`)}`
      }

      const res = await fetch(`https://api.nexabridge.se${path}`, {
        method,
        headers,
        body: (method === 'POST' ? body : undefined)
      })

      const json = await res.json()
      return json
    }
  }
}
</script>